import ReactDOM from 'react-dom/client';
import React from 'react';
import ContextProvider from './Context';
import App from './App';
import './i18n';
import { createI18n } from '@wordpress/i18n';
import { I18nProvider } from '@wordpress/react-i18n';

const i18n = createI18n();

let rootElement;

if(window.bimWebloData){
  rootElement = document.getElementById(window.bimWebloData.modelId);
}else{
  rootElement = document.getElementById('bim_weblo_panel_app');
}

const modelId = rootElement ? rootElement.getAttribute('model-id') : null;
const root = ReactDOM.createRoot(rootElement);

root.render(
  <I18nProvider i18n={i18n}>
    <ContextProvider modelId={modelId}>
      <App />
    </ContextProvider>
  </I18nProvider>
);
